import { getColumns } from "./config";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { Table } from "antd";
import personalCenterService from "@apis/personalCenterService";

export default () => {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState<any>({
    list: [],
    total: 0,
    pageNo: 1,
    pageSize: 10,
  });

  useEffect(() => {
    queryUsage({ pageNo: 1, pageSize: tableData.pageSize });
  }, []);

  const queryUsage = async ({ pageNo, pageSize }: { pageNo: number; pageSize: number }) => {
    setLoading(true);
    try {
      const res: any = await personalCenterService.queryUsage({
        pageNo,
        pageSize,
      });
      setTableData({
        list: res.data || [],
        total: res.total || 0,
        pageNo,
        pageSize,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-[16px]">
      <div className="text-[16px] font-semibold">
        <Trans>Usage</Trans>
      </div>
      <Table
        loading={loading}
        columns={getColumns()}
        rowKey={(r) => `${r.sourceType}-${r.date}`}
        dataSource={tableData.list}
        pagination={{
          current: tableData.pageNo,
          pageSize: tableData.pageSize,
          total: tableData.total,
          showQuickJumper: true,
          showSizeChanger: true,
          // showTotal: (total) => `共 ${total} 条`,
        }}
        onChange={(pagination) => {
          queryUsage({
            pageNo: pagination.current || 1,
            pageSize: pagination.pageSize || 10,
          });
        }}
      />
    </div>
  );
};
